import { SVGIcon } from '@b2c/icons';
import { ReactComponent as AdultIconComponent } from './icons/adult.svg';
import { ReactComponent as ChildIconComponent } from './icons/child.svg';
import { ReactComponent as RoomIconComponent } from './icons/room.svg';

const AdultIcon = (props) => (
  <SVGIcon component={AdultIconComponent} {...props} />
);
const ChildIcon = (props) => (
  <SVGIcon component={ChildIconComponent} {...props} />
);
const RoomIcon = (props) => (
  <SVGIcon component={RoomIconComponent} {...props} />
);
export const SearchPanelIcons = {
  AdultIcon,
  ChildIcon,
  RoomIcon,
};
